import { render, staticRenderFns } from "./DetailTransaksi.vue?vue&type=template&id=54dd689b"
import script from "./DetailTransaksi.vue?vue&type=script&lang=js"
export * from "./DetailTransaksi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports